module.exports = __webpack_public_path__ + "img/27.c75db2eb.jpg";